import { render } from "./SemenImport.vue?vue&type=template&id=633c1325"
import script from "./SemenImport.vue?vue&type=script&lang=js"
export * from "./SemenImport.vue?vue&type=script&lang=js"

import "./SemenImport.vue?vue&type=style&index=0&id=633c1325&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__